import { render, staticRenderFns } from "./CoapFields.vue?vue&type=template&id=1a5924a4&"
import script from "./CoapFields.vue?vue&type=script&lang=ts&"
export * from "./CoapFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports